<template>
    <div>
        <div class="banner">
            <img :src="require('../../../../assets/img/aboutus/aboutus_banner.png')" />
        </div>

        <div class="companyinfo">
            <el-row>
                <el-col :span="9">
                    <img src="../../../../assets/img/aboutus/aboutus_companyinfo.png"></img></el-col>
                <el-col :span="15" style="padding-left: 3em;">
                    <h1>西安锦威电子科技有限公司</h1>
                    <p>
                        西安锦威电子科技有限公司可提供工业机器人系统集成、厂务设备监测与控制系统(FMCS)、园区及企业数字化系统、节能减排与能源管理系统（EMS）、建筑智能化系统、机电安装系统等多种业务的设计、施工、软件开发、系统集成之全过程解决方案。
                    </p>
                    <br></br>
                    <p>西安锦威电子科技有限公司从智能化系统集成商起步，拥有建筑机电安装工程专业承包一级、电子与智能化专业承包一级、消防设施工程专业承包二级、装修工程专业承包二级、照明专业承包二级、电子与智能化设计乙级资质，是西门子数字化工业集团高级系统集成商、西门子基础设施集团西北区渠道商、施耐德配电和数字化业务服务商。
                    </p>
                </el-col>
            </el-row>
            <br></br>
            <p>西安锦威高度重视技术创新和积累，专门成立了由软件与算法工程师、系统集成工程师、机电设备工程师、实施经验丰富的建造师组成的研发团队。自成立至今，已自主开发了能源集中监控管理软件、智慧可视化数字管理平台软件、设备集成云平台软件，并积累了多项动力系统设备控制与能源管理方面的软件专利。
            </p>
            <br></br>
            <p>企业坚持客户至上的服务理念，十数年来，我们在中航、中烟、生物制药、电子半导体、高级别生物安全实验室、数据中心、大型公共建筑等多领域交付了大量高品质设备控制和智能化系统项目。多次获得用户“优秀供应商”的认定。
            </p>
            <br></br>
            <p>我们在烟草、芯片生产等在高耗能企业交付了多个动力系统能源改造项目，内容包括机电设备与管路改造+闭环控制完善+人工智能优化控制+能碳集中监控云平台部署等完整系列服务。每年可为客户节省数百万计的动力系统运行费用。
            </p>
            <br></br>
            <p>针对大型企业公用系统众多、管路复杂、运维设备多、人员上手困难的痛点，我们结合数字孪生、物联网、人工智能识别技术，为企业定制数字化设备运维系统，助力企业向数字化生产、高效设备运维迈进。</p>
            <br></br>
            <p>当前，国民经济已经由过去的高速发展转为向高质量发展，低质的产能、粗放的管理、落后的技术与服务、高耗能与低效率的生产模式将逐渐被市场和用户淘汰出局。<b>为适应新的发展形势，西安锦威整合人力资源，新的组织架构由数智化事业部、自动化事业部、机电工程及能源管理事业部构成。</b>除了在传统优势领域继续深耕外，西安锦威将坚持创新和研发，为客户提供更高价值服务。
            </p>
        </div>

        <div>
            <p><img src="../../../../assets/img/aboutus/aboutus_qiyewenhua.png" style="width:100%;"></img></p>
        </div>
        <div class="contactus-container">
            <contact-us></contact-us>
        </div>
    </div>
</template>
<script>
import contactUs from './contactUs.vue';
export default {
    components: {
        contactUs
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/aboutus.less';
</style>